export const getIsPastRefreshThreshold = ({
  date,
  threshold
}) => {
  if (!date) {
    return false;
  }
  // Get the current date and time
  const now = new Date();

  // Get the time difference in milliseconds
  const timeDifference = now - date;

  // Convert the time difference to hours
  const hoursDifference = timeDifference / (1000 * 60 * 60);

  // Check if the difference is greater than 8 hours
  return hoursDifference > threshold;
};